import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import { getAuthHeaders } from "../utils/auth";
import "../styles/TourManagement.css";

const TourManagement = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchTours();
  }, []);

  const fetchTours = async () => {
    try {
      const res = await fetch(`${BASE_URL}/tours`);
      const data = await res.json();
      if (data.success) {
        setTours(data.data);
      }
    } catch (error) {
      setError("Failed to fetch tours");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (tourId) => {
    try {
      const headers = getAuthHeaders(false);
      const res = await fetch(`${BASE_URL}/tours/${tourId}`, {
        method: "DELETE",
        headers,
      });

      if (res.ok) {
        setTours(tours.filter((tour) => tour._id !== tourId));
        setDeleteConfirm(null);
      } else {
        alert("Failed to delete tour");
      }
    } catch (error) {
      alert("Error deleting tour");
    }
  };

  const toggleFeatured = async (tour) => {
    try {
      const headers = getAuthHeaders(true);
      const res = await fetch(`${BASE_URL}/tours/${tour._id}`, {
        method: "PUT",
        headers,
        body: JSON.stringify({ featured: !tour.featured }),
      });

      if (res.ok) {
        fetchTours();
      } else {
        alert("Failed to update tour");
      }
    } catch (error) {
      alert("Error updating tour");
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-loader"></div>
        <p>Loading tours...</p>
      </div>
    );
  }

  return (
    <div className="tour-management">
      <div className="tour-management-header">
        <button
          className="add-tour-btn"
          onClick={() => (window.location.href = "/admin/tours/add")}
        >
          <i className="ri-add-line"></i> Add New Tour
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {tours.length === 0 ? (
        <div className="empty-state">
          <i className="ri-map-pin-line"></i>
          <h3>No Tours Found</h3>
          <p>Start by adding your first tour!</p>
          <button
            className="primary-btn"
            onClick={() => (window.location.href = "/admin/tours/add")}
          >
            Add Tour
          </button>
        </div>
      ) : (
        <div className="tours-table-container">
          <table className="tours-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Title</th>
                <th>City</th>
                <th>Price</th>
                <th>Max Group</th>
                <th>Featured</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tours.map((tour) => (
                <tr key={tour._id}>
                  <td>
                    <img
                      src={tour.photo}
                      alt={tour.title}
                      className="tour-thumbnail"
                    />
                  </td>
                  <td>{tour.title}</td>
                  <td>{tour.city}</td>
                  <td>${tour.price}</td>
                  <td>{tour.maxGroupSize}</td>
                  <td>
                    <button
                      className={`featured-toggle ${tour.featured ? "active" : ""}`}
                      onClick={() => toggleFeatured(tour)}
                    >
                      {tour.featured ? (
                        <i className="ri-star-fill"></i>
                      ) : (
                        <i className="ri-star-line"></i>
                      )}
                    </button>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="edit-btn"
                        onClick={() =>
                          (window.location.href = `/admin/tours/edit/${tour._id}`)
                        }
                      >
                        <i className="ri-edit-line"></i>
                      </button>
                      <button
                        className="delete-btn"
                        onClick={() => setDeleteConfirm(tour._id)}
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {deleteConfirm && (
        <div className="delete-modal">
          <div className="delete-modal-content">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this tour? This action cannot be undone.</p>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setDeleteConfirm(null)}
              >
                Cancel
              </button>
              <button
                className="confirm-delete-btn"
                onClick={() => handleDelete(deleteConfirm)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TourManagement;

